import React, { useCallback, useEffect, useState } from 'react';
import CrowdDetailStyle from './crowdDetailStyled';
import DetailedRules from './components/detailed_rules';
import SearchCondition from './components/search_condition';
import TablePages from './components/table_pages';
import { useDispatch } from 'dva';
import { useLocation, history } from 'umi';
import qs from 'qs';
import dayjs from 'dayjs';

const CrowdDetailList = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [modification, setModification] = useState({}); //刷新

  const { query, pathname } = location;
  // 查询条件
  const {
    tagId, //groupId
    baseDateEnd = dayjs().format('YYYY-MM-DD'),
    baseDateStart = dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
    pageNum = '1',
    pageSize = '10',
    isSearch = 'true',
    status,
    computeStatus,
  } = query;
  const timestamp = dayjs().format('YYYY-MM-DD HH-mm-ss');

  // 状态 1-启用 2-停用
  // 状态  启用/停用
  const handleStatus = () => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...status,
        tagId,
      })}`,
    );
  };
  // 人群计算状态
  const handleComputeStatus = () => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...computeStatus,
        tagId,
      })}`,
    );
  };

  // 查询
  const handleSearch = (newParams) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParams,
        pageSize,
        pageNum: '1',
        time: timestamp,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
      })}`,
    );
  };

  // 分页
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };
  //获取详情数据
  const fetchDetailData = useCallback(() => {
    dispatch({
      type: 'crowdDetail/queryGroupInfo',
      payload: {
        values: {
          groupId: tagId,
        },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, tagId, modification]);

  useEffect(() => {
    fetchDetailData();
  }, [fetchDetailData]);
  // 获取列表
  const fetchData = useCallback(() => {
    if (isSearch === 'true') {
      let startTime = baseDateStart;
      let endTime = baseDateEnd;
      if (baseDateStart) {
        startTime = dayjs(baseDateStart).format('YYYY-MM-DD');
      }
      if (baseDateEnd) {
        endTime = dayjs(baseDateEnd).format('YYYY-MM-DD');
      }
      dispatch({
        type: 'crowdDetail/getQueryGroupHistoryPaget',
        payload: {
          values: {
            baseDateStart: startTime,
            baseDateEnd: endTime,
            groupId: tagId,
            pageNum,
            pageSize,
            time: timestamp,
          },
        },
      });
    }
  }, [
    dispatch,
    pageNum,
    isSearch,
    pageSize,
    baseDateStart,
    baseDateEnd,
    tagId,
    timestamp,
  ]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <CrowdDetailStyle>
      <div data-log={JSON.stringify({
        oid: 'page_user_profile_management_detail',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })} className="crowd_detail">
        <DetailedRules
          query={query}
          handleStatus={handleStatus}
          handleComputeStatus={handleComputeStatus}
          setModification={setModification}
        ></DetailedRules>
        <SearchCondition
          query={query}
          handleSearch={(par) => handleSearch(par)}
          restClick={handleRestClick}
        ></SearchCondition>
        <TablePages
          pagination={{ pageNum, pageSize }}
          setPageData={handlePageChange}
        ></TablePages>
      </div>
    </CrowdDetailStyle>
  );
};

export default CrowdDetailList;
